/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
*/
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from "react";
import HomepageContent from "@/app/components/homepage/HomepageContent";
import {getHomepageStaticProps} from "@/app/utils/getStaticProps/getHomepageStaticProps";
import {getCommonStaticProps} from "@/app/utils/getStaticProps/getCommonStaticProps";
import {TCommonStaticDataObject} from "@/app/types/prefetchedData/commonStaticData";
import {TCmsPageAllStoresData} from "@/app/types/prefetchedData/cmsPageData";
import {TSliderWidgetsData} from "@/app/types/sliderWidgetsData";
import {STATIC_DATA_REVALIDATE_PERIOD_SECONDS} from "@/app//constants";
import getCurrentStoreCmsPageData from "@/app/connector/pages/getCunrrentStoreCmsPageData";
import getMaintenanceMode from "@/app/utils/getMaintenanceMode";
import {GetStaticProps} from 'next';

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
        ...(await serverSideTranslations(context.locale ?? '', ['common'])),
        ...(await getHomepageStaticProps()),
        maintenanceMode: await getMaintenanceMode(),
        commonStaticData: await getCommonStaticProps()
    },
    revalidate: STATIC_DATA_REVALIDATE_PERIOD_SECONDS
  }
}

export default function Index(props:{
    theme: any,
    _nextI18Next: any,
    cmsPageData: TCmsPageAllStoresData,
    sliderWidgetsData: TSliderWidgetsData,
    maintenanceMode?: boolean,
    commonStaticData: TCommonStaticDataObject
}) {
    const cmsPageData = getCurrentStoreCmsPageData(props.cmsPageData)

    return <HomepageContent cmsPageData={cmsPageData} sliderWidgetsData={props.sliderWidgetsData}/>
}
